<template>
    <app-layout ref="lo" title="Dashboard">
        <template #header>
            <BreadCrumb :breadcrumb="$page.props.bc" />
        </template>

        <div class="py-4">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                    <section class="text-gray-600 body-font">
                        <div class="container px-5 py-12 mx-auto">
                            <div class="flex flex-wrap w-full mb-5 flex-col">
                                <RoleForm
                                    @loadData="loadEzData"
                                    @changeData="changeRoleList"
                                    :selectedData="selected_role"
                                    ref="roleForm"
                                ></RoleForm>
                            </div>
                            <div class="flex flex-wrap w-full mb-5 flex-col">
                                <Toolbar>
                                    <template #start>
                                        <ButtonAdd
                                            label="Tambah"
                                            @click="tambah($event)"
                                            class="mr-1"
                                        />
                                        <ButtonDelete
                                            :disabled="
                                                selected_role.length == 0
                                            "
                                            label="Hapus"
                                            @click="hapus($event)"
                                            class="mr-1"
                                        />
                                        <ButtonEdit
                                            :disabled="
                                                selected_role.length != 1
                                            "
                                            label="Edit"
                                            @click="edit($event)"
                                            class="mr-1"
                                        />
                                    </template>

                                    <template #end> </template>
                                </Toolbar>
                            </div>
                            <div class="w-full mb-20">
                                <EzDataTable
                                    ref="ezdt"
                                    :config="ezdtConfig"
                                    @getSelectedData="getSelectedRole"
                                />
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import { defineComponent } from "vue";
import AppLayout from "@/Layouts/AppLayout";
import BreadCrumb from "@/Components/BreadCrumb";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Toolbar from "primevue/toolbar";
import ButtonAdd from "@/Components/ButtonAdd";
import ButtonDelete from "@/Components/ButtonDelete";
import ButtonEdit from "@/Components/ButtonEdit";
import InputText from "primevue/inputtext";
import RoleForm from "@/Pages/Role/Partials/RoleForm";
import EzDataTable from "@/Components/EzDataTable";
import ButtonReset from "@/Components/ButtonReset";

import { Pesan } from "@/constants";

export default defineComponent({
    components: {
        Toolbar,
        InputText,
        AppLayout,
        BreadCrumb,
        ButtonAdd,
        ButtonDelete,
        ButtonEdit,
        RoleForm,
        EzDataTable,
        ButtonReset,
    },
    data() {
        return {
            ezdtConfig: {
                dtHeader: "Role",
                globalFilter: ["name", "guard_name"],
                defineCols: [
                    {
                        field: "name",
                        header: "Name",
                        style: "min-width: 15rem",
                        isFrozen: true,
                        col_type: "text",
                    },
                    {
                        field: "guard_name",
                        header: "Guard Name",
                        style: "min-width: 15rem",
                        col_type: "text",
                    },
                    {
                        field: "created_at",
                        header: "Created At",
                        style: "min-width: 15rem",
                        col_type: "date",
                    },
                ],
                dtSourceApiRoute: {
                    list: "role.data",
                    drop: "role.bulkdelete",
                },
            },
            selected_role: [],
        };
    },
    methods: {
        changeRoleList: function (data) {
            this.$refs.ezdt.changeDataSourceList(data);
            this.$refs.ezdt.loadData();
        },
        loadEzData: function () {
            this.$refs.ezdt.loadData();
        },
        getSelectedRole: function (data) {
            this.selected_role = data;
        },
        tambah: function (event) {
            this.selected_role = [];
            this.$refs.ezdt.resetSelection();
        },
        edit: function (event) {
            this.$refs.roleForm.populateEdit(this.selected_role[0]);
        },
        hapus: function (event) {
            this.$confirm.require({
                target: event.currentTarget,
                message:
                    "Delete (" +
                    this.selected_role.length +
                    ") selected record ?",
                icon: "pi pi-info-circle",
                acceptClass: "p-button-danger",
                accept: () => {
                    let ids = [];
                    this.selected_role.forEach(function (item, index) {
                        ids.push(item.id);
                    });

                    this.$refs.ezdt.dropData(ids);
                },
                reject: () => {
                    //
                },
            });
        },
        resetPassword: function (event) {
            let self = this;
            self.$confirm.require({
                target: event.currentTarget,
                message: "Yakin akan melakukan reset ?",
                icon: "pi pi-info-circle",
                acceptClass: "p-button-danger",
                accept: () => {
                    axios
                        .post(route("role.resetpassword"), {
                            id: self.selected_role[0].id,
                        })
                        .then((res) => {
                            if (res.data.stts == Pesan.OK.STTS) {
                                self.$refs.lo.showToastOk();
                            }
                        })
                        .catch(function (error) {
                            //
                        })
                        .then(function () {
                            //
                        });
                },
                reject: () => {
                    //callback to execute when role rejects the action
                },
            });
        },
    },
});
</script>
